export enum Priority {
    Low,
    Normal,
    High,
}



// WEBPACK FOOTER //
// ./src/models/Priority.ts